<div class="form-builder-embed">
  <div *ngIf="busy" id="busy-overlay" class="col-md-12 pt-4 text-center">
    <h1 class="text-info">
      {{ busy_message }}... &nbsp;<i
        class="fas fa-circle-notch fa-spin text-info"
      ></i>
    </h1>
  </div>

  <div class="content content-forbidden" *ngIf="!isValid">
    <div class="dv-empty dv-empty-403 p-3">
      <h1>Forbidden.</h1>
      <p>
        Unauthorized access. You don't have the privilege to access this form.
        Please contact the merchant administrator.
      </p>
    </div>
  </div>

  <div>
    <div *ngIf="isValid" class="content content-form">
      <div class="col-md-12">
        <div class="row" [class.min-form-height]="isTermsConditionfieldActive">
          <div class="col-md-12 style-normalize">
            <form id="payment-form" action="/charge" method="get">
              <formio
                *ngIf="formData"
                form="form"
                (ready)="ready($event)"
                [success]="successEmitter"
                [form]="formData"
                (formLoad)="initializeFormAdjustments($event)"
                (change)="updateAmountTotal($event.data, $event)"
                [options]="options"
              ></formio>

              <div id="formioCounterPartBtnsContainer">
                <button
                  *ngIf="isCardFormActive"
                  id="credit-card-submit-mask"
                  class="btn btn-primary btn-md custom-submit-button"
                  disabled
                >
                  Submit
                </button>
                <div id="credit-card-submit"></div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
